// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================================
   Imergey Admin Panel — Global Chrome (Sidebar, Header, Content)
   Requires tokens.css to be imported first.
   ===================================================================== */

/* ----------------------------- App shell ----------------------------- */
.layout-dashboard {
  background: var(--bg-app) !important;
  font-family: var(--font-sans) !important;
}

/* ----------------------------- Sidebar (icon rail) ----------------------------- */
.layout-dashboard .ant-layout-sider.sider-primary {
  background: var(--bg-surface) !important;
  border-right: 1px solid var(--border) !important;
  box-shadow: var(--shadow-sm) !important;
  padding: 0 !important;
  overflow: hidden !important;
}

.layout-dashboard .ant-layout-sider.sider-primary::after {
  pointer-events: none !important;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-layout-sider-children {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  overflow: hidden !important;
}

/* ── Rail shell ── */
.sidenav-rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 16px 0 14px;
  gap: 4px;
}

.rail-logo {
  margin-bottom: 12px;
  flex-shrink: 0;
}
.rail-logo-link {
  display: flex;
}
.rail-logo-link img {
  width: 28px;
  height: auto;
  display: block;
}

.rail-scroll {
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  scrollbar-width: none;
}
.rail-scroll::-webkit-scrollbar {
  display: none;
}

.rail-nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  width: 100%;
  flex-shrink: 0;
}

.rail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 80px;
  padding: 7px 4px;
  border-radius: var(--r-md);
  text-decoration: none;
  transition: background var(--dur-base) var(--ease-out), transform var(--dur-fast) var(--ease-out);
}
.rail-item:hover {
  background: var(--bg-hover);
  transform: translateY(-1px);
}
.rail-item:hover .rail-icon .anticon,
.rail-item:hover .rail-item__label {
  color: var(--brand-600);
}

.rail-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
}
.rail-icon .anticon {
  font-size: 22px;
  color: var(--text-secondary);
  transition: color var(--dur-base) var(--ease-out);
}

.rail-item__label {
  font-size: 10px;
  line-height: 1.15;
  font-weight: var(--fw-medium);
  color: var(--text-muted);
  text-align: center;
  white-space: nowrap;
  transition: color var(--dur-base) var(--ease-out);
}

.sidenav-rail .rail-item.active {
  background: var(--brand-gradient) !important;
  box-shadow: var(--shadow-brand);
}
.sidenav-rail .rail-item.active .rail-icon .anticon {
  color: #fff !important;
}
.sidenav-rail .rail-item.active .rail-item__label {
  color: #fff !important;
}

.rail-divider {
  width: 36px;
  height: 1px;
  background: var(--border);
  margin: 8px 0;
  flex-shrink: 0;
}

.sidenav-rail .notification-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 9px;
  height: 9px;
  border-radius: var(--r-full);
  background: var(--error);
  border: 2px solid var(--bg-surface);
}

.rail-bottom {
  flex-shrink: 0;
  padding-top: 10px;
}

.rail-avatar {
  width: 42px;
  height: 42px;
  border-radius: var(--r-full);
  border: 2px solid var(--border);
  background: var(--brand-gradient);
  color: #fff;
  font-weight: var(--fw-bold);
  font-size: var(--fs-md);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
  padding: 0;
  transition: border-color var(--dur-fast) var(--ease-out), transform var(--dur-fast) var(--ease-out);
}
.rail-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.rail-avatar:hover {
  border-color: var(--brand-400);
  transform: scale(1.06);
}

/* ── Account popover ── */
.rail-account-popover-overlay .ant-popover-inner {
  border-radius: var(--r-lg) !important;
  box-shadow: var(--shadow-xl) !important;
  padding: 0 !important;
  overflow: hidden;
}
.rail-account-popover-overlay .ant-popover-inner-content {
  padding: 0 !important;
}
.rail-account-popover {
  width: 220px;
  padding: 14px;
}
.rail-account-popover__header {
  display: flex;
  align-items: center;
  gap: 10px;
}
.rail-account-popover__avatar {
  width: 38px;
  height: 38px;
  border-radius: var(--r-full);
  background: var(--brand-gradient);
  color: #fff;
  font-weight: var(--fw-bold);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}
.rail-account-popover__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.rail-account-popover__name {
  font-weight: var(--fw-semibold);
  color: var(--text-primary);
  font-size: var(--fs-sm);
  line-height: 1.3;
}
.rail-account-popover__email {
  font-size: var(--fs-xs);
  color: var(--text-muted);
  word-break: break-all;
}
.rail-account-popover__divider {
  height: 1px;
  background: var(--border);
  margin: 12px 0 8px;
}
.rail-account-popover__link {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 8px;
  border-radius: var(--r-sm);
  border: none;
  background: none;
  color: var(--text-secondary);
  font-size: var(--fs-sm);
  font-weight: var(--fw-medium);
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  transition: background var(--dur-fast) var(--ease-out), color var(--dur-fast) var(--ease-out);
}
.rail-account-popover__link .anticon {
  font-size: 15px;
  opacity: 0.75;
}
.rail-account-popover__link:hover {
  background: var(--bg-hover);
  color: var(--brand-600);
}
.rail-account-popover__link--danger:hover {
  background: rgba(239, 68, 68, 0.08);
  color: var(--error);
}

/* ----------------------------- Header ----------------------------- */
.layout-dashboard .ant-layout-header {
  background: rgba(255, 255, 255, 0.84) !important;
  backdrop-filter: saturate(180%) blur(12px) !important;
  -webkit-backdrop-filter: saturate(180%) blur(12px) !important;
  border-bottom: 1px solid var(--border) !important;
  padding: 10px 24px !important;
  position: sticky !important;
  top: 0 !important;
  z-index: var(--z-header) !important;
  box-shadow: none !important;
  height: auto !important;
  line-height: normal !important;
}

.layout-dashboard .ant-header-fixed {
  box-shadow: var(--shadow-sm) !important;
}

.layout-dashboard .admin-header-greeting {
  font-family: var(--font-display);
  font-size: var(--fs-lg);
  font-weight: var(--fw-bold);
  color: var(--text-primary);
  margin: 0;
  white-space: nowrap;
}

/* Profile chip */
.layout-dashboard .profileDropdownMain .ant-btn {
  height: auto !important;
  padding: 4px 10px !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--r-full) !important;
  background: var(--bg-surface) !important;
  box-shadow: var(--shadow-xs) !important;
  text-align: left;
  line-height: 1.25;
  transition: border-color var(--dur-fast) var(--ease-out) !important;
}
.layout-dashboard .profileDropdownMain .ant-btn:hover {
  border-color: var(--brand-400) !important;
}
.layout-dashboard .profileDropdownMain .userName {
  font-weight: var(--fw-semibold);
  color: var(--text-primary);
  font-size: var(--fs-sm);
}
.layout-dashboard .profileDropdownMain .userEmail {
  font-size: var(--fs-xs);
  color: var(--text-muted);
}
.layout-dashboard .profileDropdownMain .ant-image img {
  width: 40px !important;
  height: 40px !important;
  border-radius: var(--r-full) !important;
  object-fit: cover !important;
  border: 2px solid var(--border) !important;
}

/* Mobile hamburger */
.layout-dashboard .sidebar-toggler {
  color: var(--text-secondary) !important;
  padding: 0 !important;
}

/* ----------------------------- Content ----------------------------- */
.layout-dashboard .ant-layout-content.content-ant {
  padding: 24px !important;
  background: transparent !important;
}

/* ----------------------------- Mobile drawer ----------------------------- */
.drawer-sidebar .ant-drawer-body {
  padding: 0 !important;
  background: var(--bg-surface) !important;
}
.drawer-sidebar .ant-layout-sider.sider-primary {
  background: var(--bg-surface) !important;
  border-right: none !important;
  box-shadow: none !important;
}

/* ----------------------------- Responsive ----------------------------- */
@media (max-width: 992px) {
  .layout-dashboard .ant-layout-content.content-ant {
    padding: 14px !important;
  }
  .layout-dashboard .ant-layout-header {
    padding: 8px 14px !important;
  }
}

/* =====================================================================
   Admin Login Page
   ===================================================================== */
.admin-login-shell {
  display: flex;
  height: 100vh;
  overflow: hidden;
  font-family: var(--font-sans);
}

/* ── Left: form panel ── */
.admin-login-form-panel {
  flex: 0 0 42%;
  background: #fff;
  display: flex;
  /* flex-direction must be explicit here: without it the container defaults
     to row, which made \`justify-content\` control horizontal position (not
     vertical) and pinned the form to one side instead of centering it. */
  flex-direction: column;
  align-items: center;
  /* .admin-login-shell is height:100vh + overflow:hidden — fine for a short
     login form, but taller forms (e.g. signup with more fields) can exceed
     100vh and get clipped under justify-content:center. Auto margins on the
     inner wrapper center it when short and let it scroll from the top when
     tall. */
  justify-content: flex-start;
  height: 100vh;
  overflow-y: auto;
  padding: 40px 60px;
  position: relative;
  z-index: 1;
  box-shadow: 4px 0 32px rgba(7, 30, 49, 0.08);
}

.admin-login-form-inner {
  width: 100%;
  max-width: 380px;
  margin: auto 0;
}

.admin-login-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 36px;
}
.admin-login-logo img {
  width: 36px;
  height: auto;
}
.admin-login-badge {
  font-family: var(--font-display);
  font-size: 11px;
  font-weight: var(--fw-bold);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #fff;
  background: var(--brand-gradient);
  padding: 3px 10px;
  border-radius: var(--r-full);
}

.admin-login-heading {
  font-family: var(--font-display);
  font-size: 28px;
  font-weight: var(--fw-bold);
  color: var(--brand-900);
  margin: 0 0 6px;
  line-height: 1.2;
}
.admin-login-sub {
  font-size: var(--fs-sm);
  color: var(--text-muted);
  margin: 0 0 28px;
}

.admin-login-form .ant-form-item-label > label {
  font-size: var(--fs-sm) !important;
  font-weight: var(--fw-semibold) !important;
  color: var(--text-secondary) !important;
}

.admin-login-form .ant-input-affix-wrapper,
.admin-login-form .ant-input {
  border-radius: var(--r-md) !important;
  border-color: var(--border) !important;
  box-shadow: none !important;
  background: var(--bg-app) !important;
  font-size: var(--fs-sm) !important;
}
.admin-login-form .ant-input-affix-wrapper:focus,
.admin-login-form .ant-input-affix-wrapper-focused {
  border-color: var(--brand-500) !important;
  box-shadow: 0 0 0 3px rgba(59, 107, 148, 0.12) !important;
}
.admin-input-icon {
  color: var(--text-muted) !important;
  font-size: 15px !important;
}

.admin-login-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.admin-remember-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--fs-xs);
  color: var(--text-secondary);
  cursor: pointer;
}
.admin-forgot-link {
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  color: var(--brand-500);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: color var(--dur-fast) var(--ease-out);
}
.admin-forgot-link:hover {
  color: var(--brand-900);
}

.admin-login-btn.ant-btn-primary {
  background: var(--brand-gradient) !important;
  border: none !important;
  border-radius: var(--r-md) !important;
  height: 44px !important;
  font-size: var(--fs-md) !important;
  font-weight: var(--fw-bold) !important;
  letter-spacing: 0.04em;
  box-shadow: 0 4px 14px rgba(7, 30, 49, 0.28) !important;
  transition: opacity var(--dur-fast) var(--ease-out), transform var(--dur-fast) var(--ease-out) !important;
}
.admin-login-btn.ant-btn-primary:hover {
  opacity: 0.9 !important;
  transform: translateY(-1px) !important;
}

/* ── Right: brand panel ── */
.admin-login-brand-panel {
  flex: 1 1;
  background: var(--brand-gradient);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.admin-brand-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
}
.admin-brand-glow--1 {
  width: 420px;
  height: 420px;
  background: rgba(108, 229, 232, 0.18);
  top: -80px;
  right: -60px;
}
.admin-brand-glow--2 {
  width: 320px;
  height: 320px;
  background: rgba(59, 107, 148, 0.35);
  bottom: -60px;
  left: 40px;
}

.admin-brand-content {
  position: relative;
  z-index: 1;
  padding: 32px;
  max-width: 480px;
  width: 100%;
}

.admin-brand-logo-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
}
.admin-brand-logo {
  width: 44px;
  height: auto;
  filter: brightness(0) invert(1);
}
.admin-brand-name {
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: var(--fw-bold);
  color: #fff;
  letter-spacing: 0.18em;
}

.admin-brand-headline {
  font-family: var(--font-display);
  font-size: 34px;
  font-weight: var(--fw-bold);
  color: #fff;
  line-height: 1.2;
  margin: 0 0 12px;
}

.admin-brand-tagline {
  font-size: var(--fs-sm);
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.6;
  margin: 0 0 32px;
  max-width: 380px;
}

.admin-brand-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.admin-stat-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: var(--r-md);
  padding: 14px 16px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: background var(--dur-base) var(--ease-out);
}
.admin-stat-card:hover {
  background: rgba(255, 255, 255, 0.14);
}
.admin-stat-icon {
  font-size: 20px !important;
  color: var(--accent-500) !important;
  flex-shrink: 0;
}
.admin-stat-value {
  font-family: var(--font-display);
  font-size: var(--fs-sm);
  font-weight: var(--fw-bold);
  color: #fff;
  line-height: 1.2;
}
.admin-stat-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.58);
  margin-top: 0;
}

/* ── Responsive ── */
@media (max-width: 900px) {
  .admin-login-brand-panel {
    display: none;
  }
  .admin-login-form-panel {
    width: 100%;
    box-shadow: none;
  }
}

.rail-icon-dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #EF4444;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.25);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/chrome.css"],"names":[],"mappings":"AAAA;;;0EAG0E;;AAE1E,0EAA0E;AAC1E;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA,oFAAoF;AACpF;EACE,wCAAwC;EACxC,gDAAgD;EAChD,uCAAuC;EACvC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,iGAAiG;AACnG;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;AACjC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,WAAW;EACX,4BAA4B;EAC5B,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;EACX,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,mGAAmG;AACrG;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;EACrC,uCAAuC;EACvC,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,iCAAiC;EACjC,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,6FAA6F;AAC/F;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,gDAAgD;EAChD,qDAAqD;EACrD,6DAA6D;EAC7D,iDAAiD;EACjD,6BAA6B;EAC7B,2BAA2B;EAC3B,iBAAiB;EACjB,mCAAmC;EACnC,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,0CAA0C;EAC1C,uCAAuC;EACvC,wCAAwC;EACxC,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,mEAAmE;AACrE;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;EACvC,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA,wEAAwE;AACxE;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA,8EAA8E;AAC9E;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,2EAA2E;AAC3E;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb;;yEAEuE;EACvE,sBAAsB;EACtB,mBAAmB;EACnB;;;;YAIU;EACV,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,iCAAiC;EACjC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;EAC3B,oCAAoC;EACpC,kCAAkC;AACpC;AACA;;EAEE,yCAAyC;EACzC,yDAAyD;AAC3D;AACA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iDAAiD;AACnD;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,qCAAqC;EACrC,uBAAuB;EACvB,kCAAkC;EAClC,sCAAsC;EACtC,sBAAsB;EACtB,uDAAuD;EACvD,yGAAyG;AAC3G;AACA;EACE,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA,6BAA6B;AAC7B;EACE,SAAO;EACP,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,UAAU;EACV,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,0BAA0B;EAC1B,kBAAkB;EAClB,0BAA0B;EAC1B,kCAAkC;EAClC,sDAAsD;AACxD;AACA;EACE,qCAAqC;AACvC;AACA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C","sourcesContent":["/* =====================================================================\n   Imergey Admin Panel — Global Chrome (Sidebar, Header, Content)\n   Requires tokens.css to be imported first.\n   ===================================================================== */\n\n/* ----------------------------- App shell ----------------------------- */\n.layout-dashboard {\n  background: var(--bg-app) !important;\n  font-family: var(--font-sans) !important;\n}\n\n/* ----------------------------- Sidebar (icon rail) ----------------------------- */\n.layout-dashboard .ant-layout-sider.sider-primary {\n  background: var(--bg-surface) !important;\n  border-right: 1px solid var(--border) !important;\n  box-shadow: var(--shadow-sm) !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary::after {\n  pointer-events: none !important;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-layout-sider-children {\n  display: flex !important;\n  flex-direction: column !important;\n  height: 100% !important;\n  overflow: hidden !important;\n}\n\n/* ── Rail shell ── */\n.sidenav-rail {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  padding: 16px 0 14px;\n  gap: 4px;\n}\n\n.rail-logo {\n  margin-bottom: 12px;\n  flex-shrink: 0;\n}\n.rail-logo-link {\n  display: flex;\n}\n.rail-logo-link img {\n  width: 28px;\n  height: auto;\n  display: block;\n}\n\n.rail-scroll {\n  width: 100%;\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n.rail-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.rail-nav {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.rail-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  width: 80px;\n  padding: 7px 4px;\n  border-radius: var(--r-md);\n  text-decoration: none;\n  transition: background var(--dur-base) var(--ease-out), transform var(--dur-fast) var(--ease-out);\n}\n.rail-item:hover {\n  background: var(--bg-hover);\n  transform: translateY(-1px);\n}\n.rail-item:hover .rail-icon .anticon,\n.rail-item:hover .rail-item__label {\n  color: var(--brand-600);\n}\n\n.rail-icon {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n}\n.rail-icon .anticon {\n  font-size: 22px;\n  color: var(--text-secondary);\n  transition: color var(--dur-base) var(--ease-out);\n}\n\n.rail-item__label {\n  font-size: 10px;\n  line-height: 1.15;\n  font-weight: var(--fw-medium);\n  color: var(--text-muted);\n  text-align: center;\n  white-space: nowrap;\n  transition: color var(--dur-base) var(--ease-out);\n}\n\n.sidenav-rail .rail-item.active {\n  background: var(--brand-gradient) !important;\n  box-shadow: var(--shadow-brand);\n}\n.sidenav-rail .rail-item.active .rail-icon .anticon {\n  color: #fff !important;\n}\n.sidenav-rail .rail-item.active .rail-item__label {\n  color: #fff !important;\n}\n\n.rail-divider {\n  width: 36px;\n  height: 1px;\n  background: var(--border);\n  margin: 8px 0;\n  flex-shrink: 0;\n}\n\n.sidenav-rail .notification-badge {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  min-width: 9px;\n  height: 9px;\n  border-radius: var(--r-full);\n  background: var(--error);\n  border: 2px solid var(--bg-surface);\n}\n\n.rail-bottom {\n  flex-shrink: 0;\n  padding-top: 10px;\n}\n\n.rail-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: var(--r-full);\n  border: 2px solid var(--border);\n  background: var(--brand-gradient);\n  color: #fff;\n  font-weight: var(--fw-bold);\n  font-size: var(--fs-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  cursor: pointer;\n  padding: 0;\n  transition: border-color var(--dur-fast) var(--ease-out), transform var(--dur-fast) var(--ease-out);\n}\n.rail-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.rail-avatar:hover {\n  border-color: var(--brand-400);\n  transform: scale(1.06);\n}\n\n/* ── Account popover ── */\n.rail-account-popover-overlay .ant-popover-inner {\n  border-radius: var(--r-lg) !important;\n  box-shadow: var(--shadow-xl) !important;\n  padding: 0 !important;\n  overflow: hidden;\n}\n.rail-account-popover-overlay .ant-popover-inner-content {\n  padding: 0 !important;\n}\n.rail-account-popover {\n  width: 220px;\n  padding: 14px;\n}\n.rail-account-popover__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.rail-account-popover__avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: var(--r-full);\n  background: var(--brand-gradient);\n  color: #fff;\n  font-weight: var(--fw-bold);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n.rail-account-popover__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.rail-account-popover__name {\n  font-weight: var(--fw-semibold);\n  color: var(--text-primary);\n  font-size: var(--fs-sm);\n  line-height: 1.3;\n}\n.rail-account-popover__email {\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  word-break: break-all;\n}\n.rail-account-popover__divider {\n  height: 1px;\n  background: var(--border);\n  margin: 12px 0 8px;\n}\n.rail-account-popover__link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 8px;\n  border-radius: var(--r-sm);\n  border: none;\n  background: none;\n  color: var(--text-secondary);\n  font-size: var(--fs-sm);\n  font-weight: var(--fw-medium);\n  text-align: left;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background var(--dur-fast) var(--ease-out), color var(--dur-fast) var(--ease-out);\n}\n.rail-account-popover__link .anticon {\n  font-size: 15px;\n  opacity: 0.75;\n}\n.rail-account-popover__link:hover {\n  background: var(--bg-hover);\n  color: var(--brand-600);\n}\n.rail-account-popover__link--danger:hover {\n  background: rgba(239, 68, 68, 0.08);\n  color: var(--error);\n}\n\n/* ----------------------------- Header ----------------------------- */\n.layout-dashboard .ant-layout-header {\n  background: rgba(255, 255, 255, 0.84) !important;\n  backdrop-filter: saturate(180%) blur(12px) !important;\n  -webkit-backdrop-filter: saturate(180%) blur(12px) !important;\n  border-bottom: 1px solid var(--border) !important;\n  padding: 10px 24px !important;\n  position: sticky !important;\n  top: 0 !important;\n  z-index: var(--z-header) !important;\n  box-shadow: none !important;\n  height: auto !important;\n  line-height: normal !important;\n}\n\n.layout-dashboard .ant-header-fixed {\n  box-shadow: var(--shadow-sm) !important;\n}\n\n.layout-dashboard .admin-header-greeting {\n  font-family: var(--font-display);\n  font-size: var(--fs-lg);\n  font-weight: var(--fw-bold);\n  color: var(--text-primary);\n  margin: 0;\n  white-space: nowrap;\n}\n\n/* Profile chip */\n.layout-dashboard .profileDropdownMain .ant-btn {\n  height: auto !important;\n  padding: 4px 10px !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--r-full) !important;\n  background: var(--bg-surface) !important;\n  box-shadow: var(--shadow-xs) !important;\n  text-align: left;\n  line-height: 1.25;\n  transition: border-color var(--dur-fast) var(--ease-out) !important;\n}\n.layout-dashboard .profileDropdownMain .ant-btn:hover {\n  border-color: var(--brand-400) !important;\n}\n.layout-dashboard .profileDropdownMain .userName {\n  font-weight: var(--fw-semibold);\n  color: var(--text-primary);\n  font-size: var(--fs-sm);\n}\n.layout-dashboard .profileDropdownMain .userEmail {\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n}\n.layout-dashboard .profileDropdownMain .ant-image img {\n  width: 40px !important;\n  height: 40px !important;\n  border-radius: var(--r-full) !important;\n  object-fit: cover !important;\n  border: 2px solid var(--border) !important;\n}\n\n/* Mobile hamburger */\n.layout-dashboard .sidebar-toggler {\n  color: var(--text-secondary) !important;\n  padding: 0 !important;\n}\n\n/* ----------------------------- Content ----------------------------- */\n.layout-dashboard .ant-layout-content.content-ant {\n  padding: 24px !important;\n  background: transparent !important;\n}\n\n/* ----------------------------- Mobile drawer ----------------------------- */\n.drawer-sidebar .ant-drawer-body {\n  padding: 0 !important;\n  background: var(--bg-surface) !important;\n}\n.drawer-sidebar .ant-layout-sider.sider-primary {\n  background: var(--bg-surface) !important;\n  border-right: none !important;\n  box-shadow: none !important;\n}\n\n/* ----------------------------- Responsive ----------------------------- */\n@media (max-width: 992px) {\n  .layout-dashboard .ant-layout-content.content-ant {\n    padding: 14px !important;\n  }\n  .layout-dashboard .ant-layout-header {\n    padding: 8px 14px !important;\n  }\n}\n\n/* =====================================================================\n   Admin Login Page\n   ===================================================================== */\n.admin-login-shell {\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n  font-family: var(--font-sans);\n}\n\n/* ── Left: form panel ── */\n.admin-login-form-panel {\n  flex: 0 0 42%;\n  background: #fff;\n  display: flex;\n  /* flex-direction must be explicit here: without it the container defaults\n     to row, which made `justify-content` control horizontal position (not\n     vertical) and pinned the form to one side instead of centering it. */\n  flex-direction: column;\n  align-items: center;\n  /* .admin-login-shell is height:100vh + overflow:hidden — fine for a short\n     login form, but taller forms (e.g. signup with more fields) can exceed\n     100vh and get clipped under justify-content:center. Auto margins on the\n     inner wrapper center it when short and let it scroll from the top when\n     tall. */\n  justify-content: flex-start;\n  height: 100vh;\n  overflow-y: auto;\n  padding: 40px 60px;\n  position: relative;\n  z-index: 1;\n  box-shadow: 4px 0 32px rgba(7, 30, 49, 0.08);\n}\n\n.admin-login-form-inner {\n  width: 100%;\n  max-width: 380px;\n  margin: auto 0;\n}\n\n.admin-login-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 36px;\n}\n.admin-login-logo img {\n  width: 36px;\n  height: auto;\n}\n.admin-login-badge {\n  font-family: var(--font-display);\n  font-size: 11px;\n  font-weight: var(--fw-bold);\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #fff;\n  background: var(--brand-gradient);\n  padding: 3px 10px;\n  border-radius: var(--r-full);\n}\n\n.admin-login-heading {\n  font-family: var(--font-display);\n  font-size: 28px;\n  font-weight: var(--fw-bold);\n  color: var(--brand-900);\n  margin: 0 0 6px;\n  line-height: 1.2;\n}\n.admin-login-sub {\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  margin: 0 0 28px;\n}\n\n.admin-login-form .ant-form-item-label > label {\n  font-size: var(--fs-sm) !important;\n  font-weight: var(--fw-semibold) !important;\n  color: var(--text-secondary) !important;\n}\n\n.admin-login-form .ant-input-affix-wrapper,\n.admin-login-form .ant-input {\n  border-radius: var(--r-md) !important;\n  border-color: var(--border) !important;\n  box-shadow: none !important;\n  background: var(--bg-app) !important;\n  font-size: var(--fs-sm) !important;\n}\n.admin-login-form .ant-input-affix-wrapper:focus,\n.admin-login-form .ant-input-affix-wrapper-focused {\n  border-color: var(--brand-500) !important;\n  box-shadow: 0 0 0 3px rgba(59, 107, 148, 0.12) !important;\n}\n.admin-input-icon {\n  color: var(--text-muted) !important;\n  font-size: 15px !important;\n}\n\n.admin-login-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n.admin-remember-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--fs-xs);\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n.admin-forgot-link {\n  font-size: var(--fs-xs);\n  font-weight: var(--fw-semibold);\n  color: var(--brand-500);\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  transition: color var(--dur-fast) var(--ease-out);\n}\n.admin-forgot-link:hover {\n  color: var(--brand-900);\n}\n\n.admin-login-btn.ant-btn-primary {\n  background: var(--brand-gradient) !important;\n  border: none !important;\n  border-radius: var(--r-md) !important;\n  height: 44px !important;\n  font-size: var(--fs-md) !important;\n  font-weight: var(--fw-bold) !important;\n  letter-spacing: 0.04em;\n  box-shadow: 0 4px 14px rgba(7, 30, 49, 0.28) !important;\n  transition: opacity var(--dur-fast) var(--ease-out), transform var(--dur-fast) var(--ease-out) !important;\n}\n.admin-login-btn.ant-btn-primary:hover {\n  opacity: 0.9 !important;\n  transform: translateY(-1px) !important;\n}\n\n/* ── Right: brand panel ── */\n.admin-login-brand-panel {\n  flex: 1;\n  background: var(--brand-gradient);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.admin-brand-glow {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(80px);\n  pointer-events: none;\n}\n.admin-brand-glow--1 {\n  width: 420px;\n  height: 420px;\n  background: rgba(108, 229, 232, 0.18);\n  top: -80px;\n  right: -60px;\n}\n.admin-brand-glow--2 {\n  width: 320px;\n  height: 320px;\n  background: rgba(59, 107, 148, 0.35);\n  bottom: -60px;\n  left: 40px;\n}\n\n.admin-brand-content {\n  position: relative;\n  z-index: 1;\n  padding: 32px;\n  max-width: 480px;\n  width: 100%;\n}\n\n.admin-brand-logo-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 28px;\n}\n.admin-brand-logo {\n  width: 44px;\n  height: auto;\n  filter: brightness(0) invert(1);\n}\n.admin-brand-name {\n  font-family: var(--font-display);\n  font-size: 22px;\n  font-weight: var(--fw-bold);\n  color: #fff;\n  letter-spacing: 0.18em;\n}\n\n.admin-brand-headline {\n  font-family: var(--font-display);\n  font-size: 34px;\n  font-weight: var(--fw-bold);\n  color: #fff;\n  line-height: 1.2;\n  margin: 0 0 12px;\n}\n\n.admin-brand-tagline {\n  font-size: var(--fs-sm);\n  color: rgba(255, 255, 255, 0.68);\n  line-height: 1.6;\n  margin: 0 0 32px;\n  max-width: 380px;\n}\n\n.admin-brand-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.admin-stat-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.13);\n  border-radius: var(--r-md);\n  padding: 14px 16px;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  transition: background var(--dur-base) var(--ease-out);\n}\n.admin-stat-card:hover {\n  background: rgba(255, 255, 255, 0.14);\n}\n.admin-stat-icon {\n  font-size: 20px !important;\n  color: var(--accent-500) !important;\n  flex-shrink: 0;\n}\n.admin-stat-value {\n  font-family: var(--font-display);\n  font-size: var(--fs-sm);\n  font-weight: var(--fw-bold);\n  color: #fff;\n  line-height: 1.2;\n}\n.admin-stat-label {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.58);\n  margin-top: 0;\n}\n\n/* ── Responsive ── */\n@media (max-width: 900px) {\n  .admin-login-brand-panel {\n    display: none;\n  }\n  .admin-login-form-panel {\n    width: 100%;\n    box-shadow: none;\n  }\n}\n\n.rail-icon-dot {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: #EF4444;\n  border: 2px solid #ffffff;\n  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.25);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
